import "core-js/modules/es.array.push.js";
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../assets/clock.png';
import _imports_1 from '../../../assets/new/8.png';
import _imports_2 from '../../../assets/new/9.png';
import _imports_3 from '../../../assets/new/10.png';
const _withScopeId = n => (_pushScopeId("data-v-c023b7ae"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "padding": "20px"
  }
};
const _hoisted_2 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "padding-bottom": "20px",
    "border-bottom": "1px solid #ddebff"
  }
};
const _hoisted_3 = {
  style: {
    "width": "65px",
    "height": "65px",
    "margin-right": "15px",
    "background-image": "linear-gradient(\r\n                -41deg,\r\n                #2b9af3 0%,\r\n                #4bb1fa 100%\r\n              )",
    "border-radius": "5px",
    "display": "flex",
    "align-items": "center",
    "justify-content": "center",
    "flex-flow": "column",
    "color": "#ffffff",
    "font-size": "13px"
  }
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {
    "width": "45%",
    "margin-bottom": "5px"
  }
}, null, -1));
const _hoisted_5 = {
  style: {
    "flex": "1"
  }
};
const _hoisted_6 = {
  style: {
    "margin-bottom": "5px"
  }
};
const _hoisted_7 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_8 = {
  style: {
    "font-size": "23px",
    "color": "rgb(38, 158, 253)",
    "display": "flex",
    "align-items": "flex-start"
  }
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {
    "font-size": "12px",
    "font-style": "normal",
    "margin": "0 5px"
  }
}, "level", -1));
const _hoisted_10 = {
  class: "css2"
};
const _hoisted_11 = {
  style: {
    "padding": "0 20px"
  }
};
const _hoisted_12 = {
  style: {
    "color": "#181818",
    "font-size": "28px",
    "font-weight": "bold",
    "margin-bottom": "20px"
  }
};
const _hoisted_13 = ["innerHTML"];
const _hoisted_14 = {
  key: 0,
  class: "text-center font-bold",
  style: {
    "padding-top": "20px"
  }
};
const _hoisted_15 = {
  key: 1,
  class: "flex align-center justify-center",
  style: {
    "margin-top": "20px"
  }
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "box-sizing": "border-box",
    "height": "1px",
    "width": "99%",
    "border-bottom": "1px solid #9a9a9a",
    "margin": "20px auto 5px"
  }
}, null, -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-center",
  style: {
    "font-size": "4px",
    "font-style": "italic",
    "color": "#ababab",
    "padding-bottom": "150px"
  }
}, " 标识号: 09383181-F271-G153-S162-W271-3522 ", -1));
const _hoisted_18 = {
  class: "footer"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
}, null, -1));
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2
}, null, -1));
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3
}, null, -1));
import { getLocalPid } from "../../../libs/util";
import { Highlight, removeActive } from "../../../libs/Highlight.js";
import popup from "../popup/popup.vue";
import clickWhere from "./click-where.vue";
// import liveClass from "./live-class.vue";
import Header from "../../../components/header.vue";
import Questions from "./questions.vue";
import titleLabel from "./title_label.vue";
import { wechatSharefund } from "../../../libs/wechat_record.js";
import { onMounted, ref, reactive, computed, watch, nextTick } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import { articleEnter, articleAAr, bizTts, bizOralscore, articleNext } from "../../../api/index";
export default {
  __name: 'article',
  setup(__props) {
    const isMobile = computed(() => {
      let userAgentInfo = navigator.userAgent;
      let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
      let getArr = Agents.filter(i => userAgentInfo.includes(i));
      return getArr.length ? true : false;
    });
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const time = ref(0);
    let keepOrigStyles = "";
    let maxLevelSentences = [];
    let maxLevelWords = [];
    let outStandardWords = [];
    const currentText = ref("");
    const currenSentence = ref("");
    const content = ref("");
    let countdown = 0;
    const timestamp = ref(0);
    const title = ref("");
    const readLogId = ref(0);
    const wordExplains = reactive({
      data: []
    });
    const articleId = ref(0);
    const bShowQuestions = ref(false);
    const contentRef = ref(null);
    const popupRef = ref(null);
    const menu = [{
      name: "单词翻译",
      event: "search"
    }, {
      name: "语法分析",
      event: "analyse"
    }, {
      name: "句子翻译",
      event: "translate"
    }, {
      name: "智能朗读",
      event: "speak"
    }, {
      name: "语音评分",
      event: "record"
    }, {
      name: "复制句子",
      event: "copy"
    }, {
      name: "名师在线",
      event: "teacher"
    }, {
      name: "更多资源",
      event: "more"
    }];
    const getting = ref(false);
    const safeMes = computed(() => store.state.safeMes);
    const jsApiTicket = computed(() => store.state.jsApiTicket);
    const userInfo = computed(() => store.state.userInfo);
    const userId = computed(() => store.state.userId);
    onMounted(() => {
      store.commit("saveArticleId", route.query.id);
      let documentTitle = window.localStorage.getItem("title");
      if (documentTitle) document.title = documentTitle;
      if (!safeMes.value.sign) store.commit("saveSafeMes");
      getArticleData();
      const t = setInterval(() => {
        if (countdown > 0) {
          time.value = countdown;
          timerMinus();
          clearInterval(t);
        }
      }, 500);
    });
    const timeFomat = computed(() => {
      if (time.value < 0) {
        return "0:00";
      }
      if (time.value % 60 < 10) {
        return Math.floor(time.value / 60) + " : 0" + time.value % 60;
      }
      return Math.floor(time.value / 60) + ":" + time.value % 60;
    });
    const offset = computed(() => {
      if (!currentText.value || !currenSentence.value) return -1;
      return currenSentence.value.indexOf(currentText.value);
    });
    watch(currenSentence, v => {
      store.commit("changeSentence", v);
    });
    watch(currentText, v => {
      console.log(v);
      console.log("vvvvvvvvvv");
      store.commit("changeWord", v);
    });
    watch(offset, v => {
      store.commit("changeOffset", v);
    });
    const timerMinus = () => {
      setInterval(() => {
        time.value--;
      }, 1000);
    };
    const onContentContainerLoad = () => {
      let arr = contentRef.value.getElementsByTagName("IMG");
      for (let i = 0; i < arr.length; i++) {
        arr[i].style.width = "100%";
        arr[i].style.height = "auto";
        arr[i].style.maxWidth = "100%";
        arr[i].style.justifyContent = "center";
      }
    };
    const getArticleData = () => {
      let id = route.query.id;
      if (!id) id = localStorage.getItem("articleId");else {
        localStorage.setItem("articleId", id);
      }
      articleId.value = id;
      let obj = {
        ...safeMes.value,
        articleId: id,
        pid: getLocalPid()
      };
      Promise.all([articleEnter(encodeURIComponent(JSON.stringify(obj))), articleAAr(encodeURIComponent(JSON.stringify(obj)))]).then(async res => {
        let data = res[0].data;
        if (data.code) return store.commit("judgeCode", {
          code: data.code,
          msg: data.msg
        });
        let ret = data.data;
        content.value = ret.content;
        readLogId.value = ret.readLogId;
        countdown = ret.countdown;
        timestamp.value = ret.timestamp;
        keepOrigStyles = ret.keepOrigStyles;
        title.value = ret.title;
        store.commit("saveArticleTitle", title.value);
        if (safeMes.value.sign) {
          if (!jsApiTicket.value) {
            store.dispatch("getWxAppIdAndJsapi_ticket");
          } else {
            wechatSharefund();
          }
        }
        wordExplains.data = ret.wordExplains;
        maxLevelSentences = res[1].data.data.maxLevelSentences || [];
        maxLevelWords = res[1].data.data.maxLevelWords || [];
        outStandardWords = res[1].data.data.outStandardWords || [];
        maxLevelSentences = maxLevelSentences.map(item => {
          const prefix = item.split(/[\\.|\\?|!|！|？|。]\s*["|”]/)[0];
          let sss = "";
          if (prefix.length > item.length / 4 * 3) {
            sss = prefix;
          } else {
            sss = item;
          }
          return sss;
        });
        await nextTick();
        onContentContainerLoad();
        Highlight(contentRef.value, maxLevelSentences, maxLevelWords, outStandardWords);
        bShowQuestions.value = true;
      }).catch(() => {
        return ElMessage.error("获取文章内容失败");
      });
    };
    const copyHandler = (txt = "") => {
      let iscopy = false;
      if (document) {
        let textArea = document.createElement("textarea");
        textArea.style.position = "fixed";
        textArea.style.top = 0;
        textArea.style.left = 0;
        textArea.style.width = "2em";
        textArea.style.height = "2em";
        textArea.style.padding = 0;
        textArea.style.border = "none";
        textArea.style.outline = "none";
        textArea.style.boxShadow = "none";
        textArea.style.background = "transparent";
        textArea.value = txt;
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand("copy");
          iscopy = true;
        } catch (err) {
          console.log("不能使用这种方法复制内容" + err.toString());
        }
        document.body.removeChild(textArea);
      }
      return iscopy;
    };
    const speakHandler = value => {
      let id = route.query.id;
      if (!id) {
        id = localStorage.getItem("articleId");
      } else {
        localStorage.setItem("articleId", id);
      }
      articleId.value = id;
      let obj = {
        ...safeMes.value,
        articleId: id,
        readLogId: readLogId.value,
        content: encodeURI(value)
      };
      bizTts(encodeURIComponent(JSON.stringify(obj))).then(({
        data: {
          code,
          msg
        }
      }) => {
        if (code !== 0) {
          ElMessage.error(msg || "操作失败！");
        }
      });
    };
    const remarkHandler = () => {
      let id = route.query.id;
      if (!id) id = localStorage.getItem("articleId");else {
        localStorage.setItem("articleId", id);
      }
      articleId.value = id;
      let obj = {
        ...safeMes.value,
        articleId: id,
        cardNumber: ""
      };
      bizOralscore(encodeURIComponent(JSON.stringify(obj))).then(({
        data: {
          code,
          msg
        }
      }) => {
        if (code !== 0) {
          ElMessage.error(msg || "操作失败！");
        }
      });
    };
    const menuItemClick = ({
      event
    }) => {
      console.log(event);
      console.log("**********");
      if (event === "search") {
        speakHandler(currentText.value);
      } else if (event === "copy") {
        const isOk = copyHandler(currenSentence.value);
        if (isOk) {
          ElMessage.success("复制成功！");
        }
      } else if (event === "speak") {
        speakHandler(currenSentence.value);
      } else if (event === "remark") {
        remarkHandler();
      }
    };
    const popVis = e => {
      if (!e.target || !e.target.classList.contains("word") || !e.target.textContent.trim()) {
        return;
      }
      const parent = e.target.parentNode;
      if (parent && parent.childNodes) {
        if (keepOrigStyles) {
          currenSentence.value = [...parent.childNodes].reduce((t, v) => {
            const s = v.childNodes[0] && v.childNodes[0].nodeValue;
            if (s) {
              t += s;
            }
            return t;
          }, "");
        } else {
          currenSentence.value = parent.textContent.trim();
        }
      }
      console.log(e);
      console.log(e.target.childNodes[0].nodeValue);
      console.log("eeeeeeee");
      const text = e.target.childNodes[0].nodeValue;
      currentText.value = text || "";
      popupRef.value.show(e.pageX + 15, e.pageY + 10);
    };
    const changeArticle = type => {
      console.log(getLocalPid());
      let obj = {
        ...safeMes.value,
        articleId: articleId.value,
        readLogId: readLogId.value,
        timestamp: timestamp.value,
        reason: type,
        pid: getLocalPid()
      };
      getting.value = true;
      articleNext(encodeURIComponent(JSON.stringify(obj))).then(res => {
        let data = res.data;
        if (data.code) {
          return store.commit("judgeCode", {
            code: data.code,
            msg: data.msg
          });
        }
        let ret = data.data;
        let href = window.location.href;
        window.location.href = href.substring(0, href.lastIndexOf("/")) + "/article?id=" + ret.articleId + "&pid=" + getLocalPid();
      }).catch(() => {
        getting.value = false;
        return ElMessage.error("获取文章失败");
      });
    };
    const hideTextColorHandler = () => {
      removeActive();
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass([isMobile.value ? 'container' : 'containerPc'])
      }, [_createElementVNode("div", {
        class: "bg-white",
        style: _normalizeStyle({
          height: isMobile.value ? '100%' : '80%'
        })
      }, [_createVNode(Header, {
        title: '阅读中心'
      }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createTextVNode(" " + _toDisplayString(timeFomat.value), 1)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, "ID：" + _toDisplayString(userId.value), 1), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, [_createTextVNode(_toDisplayString(userInfo.value.level), 1), _hoisted_9]), _createElementVNode("span", _hoisted_10, [_createElementVNode("span", {
        class: "css1",
        style: _normalizeStyle({
          width: userInfo.value.level / 396 * 100 + '%'
        })
      }, null, 4)])])])])]), _createVNode(titleLabel, {
        title: title.value,
        labelList: wordExplains.data
      }, null, 8, ["title", "labelList"]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString(title.value), 1), _createElementVNode("div", {
        ref_key: "contentRef",
        ref: contentRef,
        id: "content-wrapper",
        style: {
          "color": "#4a4a4a",
          "line-height": "22px",
          "overflow-wrap": "break-word",
          "word-wrap": "break-word",
          "word-break": "keep-all",
          "white-space": "pre-line"
        },
        innerHTML: content.value,
        onClick: popVis
      }, null, 8, _hoisted_13)]), _createVNode(popup, {
        menu: menu,
        width: 280,
        ref_key: "popupRef",
        ref: popupRef,
        sentence: currenSentence.value,
        onMenuItemClick: menuItemClick,
        articleId: articleId.value,
        readLogId: readLogId.value,
        onClose: hideTextColorHandler
      }, null, 8, ["sentence", "articleId", "readLogId"]), _createVNode(clickWhere, {
        articleId: articleId.value
      }, null, 8, ["articleId"]), getting.value ? (_openBlock(), _createElementBlock("div", _hoisted_14, " 获取中... ")) : _createCommentVNode("", true), _unref(store).state.userId ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("button", {
        style: {
          "background-color": "#ec5f74",
          "padding": "8px 12px",
          "border": "none",
          "border-radius": "4px",
          "margin": "0 5px"
        },
        class: "text-white font-bold",
        onClick: _cache[0] || (_cache[0] = $event => changeArticle('tooHard'))
      }, " 看不懂 "), _createElementVNode("button", {
        style: {
          "background-color": "#9adfbf",
          "padding": "8px 12px",
          "border": "none",
          "border-radius": "4px"
        },
        class: "text-white font-bold",
        onClick: _cache[1] || (_cache[1] = $event => changeArticle('changeSubject'))
      }, " 换主题 ")])) : _createCommentVNode("", true), _hoisted_16, bShowQuestions.value && _unref(store).state.userId ? (_openBlock(), _createBlock(Questions, {
        key: 2,
        articleId: articleId.value,
        readLogId: readLogId.value,
        timestamp: timestamp.value
      }, null, 8, ["articleId", "readLogId", "timestamp"])) : _createCommentVNode("", true), _hoisted_17], 4), _createElementVNode("div", _hoisted_18, [_createElementVNode("a", {
        href: "javascript: void(0)",
        style: {
          "color": "#35b9ff"
        },
        onClick: _cache[2] || (_cache[2] = $event => _unref(router).push({
          name: 'index',
          query: {
            pid: _ctx.pid
          }
        }))
      }, [_hoisted_19, _createTextVNode(" 原版阅读 ")]), _createElementVNode("a", {
        href: "javascript: void(0)",
        onClick: _cache[3] || (_cache[3] = $event => _unref(router).push({
          name: 'photo',
          query: {
            pid: _ctx.pid
          }
        }))
      }, [_hoisted_20, _createTextVNode(" AI工具 ")]), _createElementVNode("a", {
        href: "javascript: void(0)",
        onClick: _cache[4] || (_cache[4] = $event => _unref(router).push({
          name: 'my',
          query: {
            pid: _unref(getLocalPid)()
          }
        }))
      }, [_hoisted_21, _createTextVNode(" 个人中心 ")])])], 2);
    };
  }
};